import { create } from 'zustand';

const usePointsStore = create((set) => ({
  pointsTable: [],
  setPointsTable: (newPointsTable) => set((state) => ({ ...state, pointsTable: newPointsTable })),
}));

export default usePointsStore;

